<template>
  <svg width="18" height="12" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 6L7.5 11.5L17 2" stroke="#002157" stroke-width="3"/>
  </svg>
</template>
